import React from "react";
import { ISVG } from "./interface";

const SVG: React.FC<ISVG> = ({
  style = {},
  fill = "var(--tlx-surface-bg-surface)",
  width = 48,
  height = 48,
  className = "",
  viewBox,
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox || `0 0 ${width} ${height}`}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M9.8 9C8.90312 9 8.47188 9.5 7 9.5C5.52812 9.5 5.1 9 4.2 9C1.88125 9 0 10.8813 0 13.2V14.5C0 15.3281 0.671875 16 1.5 16H12.5C13.3281 16 14 15.3281 14 14.5V13.2C14 10.8813 12.1187 9 9.8 9ZM13 14.5C13 14.775 12.775 15 12.5 15H1.5C1.225 15 1 14.775 1 14.5V13.2C1 11.4344 2.43437 10 4.2 10C4.8125 10 5.42188 10.5 7 10.5C8.575 10.5 9.1875 10 9.8 10C11.5656 10 13 11.4344 13 13.2V14.5ZM7 8C9.20938 8 11 6.20937 11 4C11 1.79063 9.20938 0 7 0C4.79063 0 3 1.79063 3 4C3 6.20937 4.79063 8 7 8ZM7 1C8.65312 1 10 2.34687 10 4C10 5.65312 8.65312 7 7 7C5.34688 7 4 5.65312 4 4C4 2.34687 5.34688 1 7 1Z"
      fill={fill}
    />
  </svg>
);

export default SVG;
